<template>
    <header-drop-menu :label="nickname" @command="onCommand">
        <isc-dropdown-item command="changePassword">修改密码</isc-dropdown-item>
        <isc-dropdown-item command="quit">退出登录</isc-dropdown-item>

        <template #append>
            <change-password-dialog ref="changePasswordDialog"></change-password-dialog>
        </template>
    </header-drop-menu>
</template>

<script>
import HeaderDropMenu from '@/components/desk-header/header-drop-menu';
import ChangePasswordDialog from '@/components/desk-header/components/user-dialog/change-password-dialog';
import { openConfirm, showError } from '@/utils/message.ts';
import { logout } from '@/service/system';
import { desk } from '@isyscore/messenger';
export default {
    name: 'HeaderUser',
    components: { ChangePasswordDialog, HeaderDropMenu },
    computed: {
        nickname() {
            return this.$store.state.sso.nickname || '用户';
        }
    },
    methods: {
        onCommand(command) {
            switch (command) {
                case 'changePassword':
                    this.$refs.changePasswordDialog.open();
                    break;

                case 'quit':
                    this.quit();
                    break;
            }
        },

        async quit() {
            try {
                await openConfirm('确定要退出登录吗？', '退出登录');
            } catch (err) {
                return;
            }

            try {
                await logout();
            } catch (err) {
                return showError('登出失败：' + err);
            }

            desk.localStorage.clear();
            desk.sessionStorage.clear();
            const reten = encodeURIComponent(location.origin);
            location.assign(`${ENVS.ssoUrl}?return=${reten}`);
        }
    }
};
</script>

<style lang="scss" scoped></style>
